/* localStorage that never throws: it can be missing or blocked (private
   windows, cleared site data), and the site must work without it. */
export function readJSON(key, fallback) {
  try {
    const raw = window.localStorage.getItem(key)
    return raw == null ? fallback : JSON.parse(raw)
  } catch (e) {
    return fallback
  }
}

export function writeJSON(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    // storage full or blocked: keep working in memory
  }
}

export function removeKey(key) {
  try {
    window.localStorage.removeItem(key)
  } catch (e) {
    // ignore
  }
}

export const KEYS = {
  myTopics: 'instapres.myTopics',
  followedSources: 'instapres.followedSources',
  recentSearches: 'instapres.recentSearches',
  consent: 'instapres.consent',
  migratedProfile: 'instapres.migratedProfile',
  commentToken: 'instapres.commentToken',
  commentName: 'instapres.commentName',
}
